function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import SpinnerApple from "noood/comp/ui/spinner/Spinner.Apple";
import { cloudinaryUtil } from "noood/comp/ui/image-viewer/cloudinaryUtil";
import Icon from "noood/comp/ui/feather-icon/Icon";
import { useModalImageViewerContext } from "noood/comp/ui/image-viewer/ModalImageViewerProvider";
export default function CloudinaryImg(props) {
  var _useModalImageViewerC, _props$borderRadius, _props$backgroundColo;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    img = _useState2[0],
    setImg = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var __viewImage = (_useModalImageViewerC = useModalImageViewerContext()) === null || _useModalImageViewerC === void 0 ? void 0 : _useModalImageViewerC.__open;
  useEffect(function () {
    if (props.filename) {
      var _props$resourceImageS;
      var url = cloudinaryUtil.makeThumbnail({
        size: (_props$resourceImageS = props.resourceImageSize) !== null && _props$resourceImageS !== void 0 ? _props$resourceImageS : "M",
        filename: props.filename
      });
      var i = new Image();
      i.src = url;
      i.onload = function () {
        setImg(i);
      };
      i.onerror = function (e) {
        setImg(null);
        setErrors(['ERROR']);
      };
    } else {
      setImg(null);
      // setErrors(['NO_IMG'])
    }
  }, [props.filename]);
  var style = _objectSpread({
    width: props.width,
    height: props.height,
    borderRadius: "".concat((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 15, "px"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: (_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : "var(--shade-10)"
  }, props.style);
  if (img === undefined) {
    return /*#__PURE__*/React.createElement("div", _extends({
      style: style
    }, stylex.props(props.stylex)), (props.showLoaderGif === void 0 || props.showLoaderGif) && /*#__PURE__*/React.createElement(SpinnerApple, {
      size: 20
    }));
  }
  if (img === null && errors !== void 0 && errors !== null) {
    return /*#__PURE__*/React.createElement("div", _extends({
      style: style
    }, stylex.props(props.stylex)), /*#__PURE__*/React.createElement(Icon, {
      icon: "cloud-off",
      color: "var(--shade-10)",
      size: 20
    }));
  }
  if (img === null && (errors === void 0 || errors === null)) {
    return /*#__PURE__*/React.createElement("div", _extends({
      style: style
    }, stylex.props(props.stylex)));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, img && /*#__PURE__*/React.createElement("div", _extends({
    style: _objectSpread(_objectSpread({}, style), {}, {
      cursor: props.__click || props.popupView ? "pointer" : "unset",
      backgroundImage: "url(".concat(img.src, ")"),
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundSize: props.width > props.height || props.width == props.height ? "".concat(props.width, "px auto") : "auto ".concat(props.height, "px")
    }),
    onClick: function onClick() {
      var _props$__click;
      if (props.popupView) {
        __viewImage({
          urls: [cloudinaryUtil.baseURL(props.filename)],
          idx: 0
        });
      }
      (_props$__click = props.__click) === null || _props$__click === void 0 || _props$__click.call(props, img);
    }
  }, stylex.props(props.stylex)), props.children));
}

// @ts-ignore